import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ProductClass } from "../../../../core/json/ProductClass";
import {
  addNewProduct,
  getGroupEntryByGuid,
  getProductTypeguid,
  getUnitguid,
} from "../../../../services/MasterApiServices";
import toast from "react-hot-toast";
import axios from "axios";
import { fetchBrand } from "../../../../redux/userSetting";
import AddProduct from "../AddProduct";
import { X } from "feather-icons-react/build/IconComponents";
import { PmGalleryIcon, PmImageIcon } from "./pmUi";

function AddOtherDescription({
  productName,
  register,
  errors,
  watch,
  setValue,
  productImages,
  setProductImages,
  setThumbnailImage,
  thumbnailImage,
}) {
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { product, productsection } = useSelector((state) => state.productdata);
  const { brandList } = useSelector((state) => state.usersetting);

   const [thumbnailPreview, setThumbnailPreview] = useState(null);
  // const [thumbnailImage, setThumbnailImage] = useState(null);

  const [productImagePreviews, setProductImagePreviews] = useState([]);
  const [fileList, setFileList] = useState([]);

  // const transtext = watch("ShortDescription");

  useEffect(() => {
    dispatch(fetchBrand());
  }, []);

  const API_KEY = process.env.REACT_APP_TRANSLATION_API_KEY;

  const languages = [
    { code: "ar", name: "Arabic" },
    // { code: "hi", name: "Hindi" },
    // { code: "ml", name: "Malayalam" },
  ];

  // useEffect(() => {
  //   setValue("ShortDescription", ShortDescription);
  // }, [ShortDescription, setValue]);

  // useEffect(() => {
  //   if (product?.ShortDescription) {
  //     setValue("ShortDescription", product.ShortDescription);
  //   }
  // }, [product, setValue]);

  const handleTranslation = async (targetLanguage) => {
    if (!productName) {
      toast.error("Please enter a product name to translate.");
      return;
    }

    const url = `https://translation.googleapis.com/language/translate/v2?key=${API_KEY}`;

    try {
      const response = await axios.post(
        url,
        {
          q: productName,
          target: targetLanguage,
        },
        {
          // By setting `requireheader: false`, the global headers will be blocked
          requireheader: false,
        }
      );

      const translatedText = response.data.data.translations[0].translatedText;
      setValue("ShortDescription", translatedText); // Update Arabic Description
      toast.success("Translation completed!");
    } catch (error) {
      console.error(
        "Translation error:",
        error.response?.data || error.message
      );
      toast.error("Error translating text");
    }
  };

  console.log(watch("ShortDescription"), "watch");

  console.log(brandList, "braaaaaaaaaand");

  // Function to Resize Image
  // const resizeImage = (file, width, height, callback) => {
  //   const reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = (event) => {
  //     const img = new Image();
  //     img.src = event.target.result;
  //     img.onload = () => {
  //       const canvas = document.createElement("canvas");
  //       const ctx = canvas.getContext("2d");

  //       canvas.width = width;
  //       canvas.height = height;
  //       ctx.drawImage(img, 0, 0, width, height);

  //       canvas.toBlob((blob) => {
  //         callback(new File([blob], file.name, { type: file.type }));
  //       }, file.type);
  //     };
  //   };
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];
  // if (fileName) {
  //   const reader = new FileReader();
  //   reader.readAsDataURL(fileName);

  //   reader.onloadend = () => {
  //     setThumbnailImage(reader.result); // Base64 string
  //   };
  // }
  //   if (file) {
  //     resizeImage(file, 150, 150, (resizedFile) => {
  //       setThumbnailImage(resizedFile);
  //       setThumbnailPreview(URL.createObjectURL(resizedFile));
  //     });
  //   }
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];
  // console.log(file,"fileeeeeeeeeeeeeeeeee");

  // const fileName = String(file.name);
  // setThumbnailImage(fileName)
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const imageUrl = URL.createObjectURL(file);
  //     console.log(imageUrl, "Generated Image URL");
  //     setThumbnailImage(imageUrl); // Store the image URL instead of the file
  //     setThumbnailPreview(imageUrl);
  //   }
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file); // Convert to Base64

  //     reader.onloadend = () => {
  //       console.log(reader.result, "Base64 Image URL");
  //       setThumbnailImage(reader.result); // Store Base64 string
  //       setThumbnailPreview(reader.result);
  //     };
  //   }
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];

  //   if (!file) {
  //     console.warn("No file selected");
  //     return;
  //   }

  //   console.log(file, "Selected File");

  //   const reader = new FileReader();

  //   reader.onload = () => {
  //     const arrayBuffer = reader.result; // This is an ArrayBuffer
  //     const byteArray = new Uint8Array(arrayBuffer); // Convert to byte array

  //     console.log(byteArray, "Byte Array");

  //     // Example: Store it in state or send it to backend
  //     setThumbnailImage(byteArray); // make sure your state is ready for Uint8Array
  //   };

  //   reader.onerror = () => {
  //     console.error("Error reading file as ArrayBuffer");
  //   };

  //   reader.readAsArrayBuffer(file);
  // };

  // const handleProductImagesChange = (event) => {
  //   const files = Array.from(event.target.files);

  //   if (productImages.length + files.length > 3) {
  //     toast.error("You can upload a maximum of 3 images.");
  //     return;
  //   }

  //   files.forEach((file) => {
  //     resizeImage(file, 550, 550, (resizedFile) => {
  //       setProductImages((prevImages) => [...prevImages, resizedFile]);
  //       setProductImagePreviews((prevPreviews) => [...prevPreviews, URL.createObjectURL(resizedFile)]);
  //     });
  //   });
  // };

  //   const handleProductImagesChange = (event) => {
  //     const files = Array.from(event.target.files);
  // console.log(files,"Image upload");
  // const fileArray = Array.from(files).map((file) => URL.createObjectURL(file));
  // console.log(fileArray,"FILE Image");

  //     if (productImages.length + files.length > 3) {
  //         toast.error("You can upload a maximum of 3 images.");
  //         return;
  //     }
  //   const newFiles = fileArray.map((url) => ({
  //     // guID: "",
  //     // prodGuID: "",
  //     dImage: url,
  //     // isDeleted: 0,
  //   }));
  //   console.log(newFiles,"NEWFILES");

  //   //setProductImages(newFiles);
  //  // setProductImagePreviews(fileArray);
  //   files.forEach((newFiles) => {

  //         setProductImages((newFiles) => [...newFiles, newFiles]);
  //         setProductImagePreviews((fileArray) => [...fileArray,]);

  //     });

  // };

  // const handleProductImagesChange = (event) => {
  //   const files = Array.from(event.target.files);
  //   console.log(files, "Image upload");

  //   const fileArray = files.map((file) => URL.createObjectURL(file));
  //   console.log(fileArray, "FILE Image");

  //   if (productImages.length + files.length > 3) {
  //       toast.error("You can upload a maximum of 3 images.");
  //       return;
  //   }

  //   const newFiles = fileArray.map((url) => ({
  //       dImage: url,
  //   }));

  //   console.log(newFiles, "NEWFILES");

  //   // Correctly update state
  //   setProductImages((prevImages) => [...prevImages, ...newFiles]);
  //   setProductImagePreviews((prevPreviews) => [...prevPreviews, ...fileArray]);
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) {
  //     console.warn("No file selected");
  //     setThumbnailImage(""); // ✅ Convert null to empty string
    
  //     return;
  //   }
  //   setThumbnailImage(file); // or handle as needed
  //   // else
  //   // {setThumbnailImage(file);}

  //   // Optional: store file object if needed
   
  // };

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.warn("No file selected");
      setThumbnailImage("");
      return;
    }
  
    const reader = new FileReader();
  
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        canvas.width = 200;
        canvas.height = 200;
  
        // Draw image resized to 200x200
        ctx.drawImage(img, 0, 0, 200, 200);
  
        // Get the new image as a Blob or data URL
        canvas.toBlob((blob) => {
          const resizedFile = new File([blob], file.name, { type: file.type });
          setThumbnailImage(resizedFile);
  
          const previewURL = URL.createObjectURL(resizedFile);
          setThumbnailPreview(previewURL);
        }, file.type);
      };
      img.src = e.target.result;
    };
  
    reader.readAsDataURL(file);
  };

//   const handleProductImagesChange = (event) => {
//     const files = Array.from(event.target.files);
//     console.log(files, "Image uploaddddddddddddddd");

//     if (productImages.length + files.length > 3) {
//       toast.error("You can upload a maximum of 3 images.");
//       return;
//     }
//     else {
// setProductImages(files);}

//   };


const handleProductImagesChange = (event) => {
  const files = Array.from(event.target.files);

  if (productImages.length + files.length > 3) {
    toast.error("You can upload a maximum of 3 images.");
    return;
  }

  const resizedImagesPromises = files.map((file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = 600;
          canvas.height = 600;

          ctx.drawImage(img, 0, 0, 600, 600);

          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, { type: file.type });
              const previewURL = URL.createObjectURL(resizedFile);
              resolve({ file: resizedFile, preview: previewURL });
            }
          }, file.type);
        };
        img.src = e.target.result;
      };

      reader.readAsDataURL(file);
    });
  });

  Promise.all(resizedImagesPromises).then((resizedData) => {
    const resizedFiles = resizedData.map((item) => item.file);
    const previewUrls = resizedData.map((item) => item.preview);

    setProductImages((prev) => [...prev, ...resizedFiles]);
    setProductImagePreviews((prev) => [...prev, ...previewUrls]);
  });
};



  const removeProductImage = (index) => {
    const updatedImages = [...productImages];
    const updatedPreviews = [...productImagePreviews];
    updatedImages.splice(index, 1);
    updatedPreviews.splice(index, 1);
    setProductImages(updatedImages);
    setProductImagePreviews(updatedPreviews);
  };

  return (
    <div className="pm-panel">
      {/* ---------- description + brand ---------- */}
      <div className="pm-secthead">Description &amp; brand</div>
      <div className="pm-formgrid">
        <div className="pm-f tall">
          <label className="pm-flabel" htmlFor="ShortDescription">
            Detailed Description
          </label>
          <textarea
            id="ShortDescription"
            placeholder="Detailed Description"
            rows={8}
            {...register("ShortDescription", {
          //    required: "Detailed Description is required",
            })}
          />
        </div>

        <div className="pm-f">
          <label className="pm-flabel">Brand</label>
          <select {...register("brand")}>
            <option value="">Select Brand</option>
            {brandList?.map((group) => (
              <option key={group.guid} value={group.guid}>
                {group.name}
              </option>
            ))}
          </select>
        </div>

        <div className="pm-f">
          <label className="pm-flabel">Min Price</label>
          <input
            type="number"
            placeholder=""
            className="pm-num"
            min={0}
            defaultValue={0}
            {...register("MinPrice")}
          />
        </div>
      </div>

      {/* ---------- reorder ---------- */}
      <div className="pm-secthead gap">ReOrder</div>
      <div className="pm-formgrid">
        <div className="pm-f">
          <label className="pm-flabel">
            Min Quantity<span className="pm-req">*</span>
          </label>
          <input
            type="number"
            placeholder=""
            className={"pm-num" + (errors?.MinQty ? " err" : "")}
            min={0}
            defaultValue={0}
            {...register("MinQty", {
              required: "Min Quantity is required",
            })}
          />
          {errors?.MinQty && (
            <span className="error pm-errtext">{errors.MinQty.message}</span>
          )}
        </div>

        <div className="pm-f">
          <label className="pm-flabel">
            Max Quantity<span className="pm-req">*</span>
          </label>
          <input
            type="number"
            placeholder=""
            className={"pm-num" + (errors?.MaxQty ? " err" : "")}
            min={0}
            defaultValue={0}
            {...register("MaxQty", {
              required: "Max Quantity is required",
            })}
          />
          {errors?.MaxQty && (
            <span className="error pm-errtext">{errors.MaxQty.message}</span>
          )}
        </div>

        <div className="pm-f">
          <label className="pm-flabel">
            Reorder Level<span className="pm-req">*</span>
          </label>
          <input
            type="number"
            placeholder=""
            className={"pm-num" + (errors?.ReorderLevel ? " err" : "")}
            defaultValue={0}
            min={0}
            {...register("ReorderLevel", {
              required: "Reorder Level is required",
            })}
          />
          {errors?.ReorderLevel && (
            <span className="error pm-errtext">{errors.ReorderLevel.message}</span>
          )}
        </div>

        <div className="pm-f">
          <label className="pm-flabel">
            Reorder Quantity<span className="pm-req">*</span>
          </label>
          <input
            type="number"
            placeholder=""
            className={"pm-num" + (errors?.ReorderQty ? " err" : "")}
            defaultValue={0}
            min={0}
            {...register("ReorderQty", {
              required: "Reorder Quantity is required",
            })}
          />
          {errors?.ReorderQty && (
            <span className="error pm-errtext">{errors.ReorderQty.message}</span>
          )}
        </div>
      </div>

      {/* ---------- others ---------- */}
      <div className="pm-secthead gap">Others</div>
      <label className="pm-switch">
        <input type="checkbox" {...register("IsMenuItem")} />
        <span className="pm-track" />
        Quick Item
      </label>

      {/* ---------- images ---------- */}
      <div className="pm-secthead gap">Add Images</div>
      <div className="pm-formgrid">
        {/* Thumbnail Image Upload (Mandatory) */}
        <div className="pm-f">
          <span className="pm-flabel">
            Thumbnail Image<span className="pm-req">*</span>
          </span>
          <label className="pm-drop">
            <span className="pm-ph">
              {thumbnailPreview ? (
                <img src={thumbnailPreview} alt="Thumbnail Preview" />
              ) : (
                <PmImageIcon />
              )}
            </span>
            <span className="pm-lbl">
              {thumbnailPreview ? "Replace the thumbnail" : "Add a thumbnail"}
            </span>
            <span className="pm-pick">Choose file</span>
            <span className="pm-sz">150 × 150 px</span>
            <input
              type="file"
              accept="image/*"
              onChange={handleThumbnailChange}
            />
          </label>
          {/* {errors?.thumbnailImage && <span className="error text-danger">{errors.thumbnailImage.message}</span>} */}
        </div>

        {/* Product Detail Images (Multiple Uploads) */}
        <div className="pm-f">
          <span className="pm-flabel">Product Detail Images</span>
          <label
            className={
              "pm-drop" + (productImages.length >= 3 ? " is-disabled" : "")
            }
          >
            <span className="pm-ph">
              <PmGalleryIcon />
            </span>
            <span className="pm-lbl">Up to 3 images</span>
            <span className="pm-pick">Add images</span>
            <span className="pm-sz">550 × 550 px · pick several at once</span>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleProductImagesChange}
              disabled={productImages.length >= 3}
            />
          </label>
          {productImagePreviews.length > 0 && (
            <div className="pm-gallery">
              {productImagePreviews.map((image, index) => (
                <span key={index} className="pm-gitem">
                  <img src={image} alt="Product Detail" />
                  <button
                    type="button"
                    className="pm-x"
                    aria-label={`Remove image ${index + 1}`}
                    onClick={() => removeProductImage(index)}
                  >
                    <X />
                  </button>
                </span>
              ))}
            </div>
          )}
          <div className={"pm-gcount" + (productImages.length >= 3 ? " full" : "")}>
            {productImages.length >= 3
              ? "Maximum 3 images allowed."
              : `${productImages.length} of 3 images`}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddOtherDescription;
